<template>
  <div class="publish-goods-container">
    <div>
      <h2><span class="product-tips" @click="$router.back()">商品管理</span> / {{ pageTitle }}</h2>
    </div>
    <WenXinTips />
    <BaseInfo ref="baseInfoRef" />
    <SaleInfoNormal ref="saleInfoNormalRef" />
    <DeliveryInfo ref="deliveryInfoRef" />
    <GraphicInfo ref="graphicInfoRef" />
    <el-row type="flex" justify="end" style="margin-top: 20px">
      <el-col :span="14">
        <el-button @click="cancelClick">取消</el-button>
        <el-button type="primary" @click="onSubmit">发布</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { goodsSave } from "@/api/publishGoods/publishGoods";
import WenXinTips from "@/views/seller/publishGoods/components/WenXinTips.vue";
import BaseInfo from "./components/BaseInfo.vue";
import DeliveryInfo from "./components/DeliveryInfo.vue";
import GraphicInfo from "./components/GraphicInfo.vue";
import SaleInfoNormal from "./components/SaleInfoNormal.vue";

export default {
  components: {
    WenXinTips,
    BaseInfo,
    SaleInfoNormal,
    DeliveryInfo,
    GraphicInfo,
  },
  data() {
    return {
      spuId: this.$route.query.spuId,
    };
  },
  computed: {
    pageTitle() {
      return this.spuId ? "编辑套餐" : "新建套餐";
    },
  },
  created() {
    if (this.spuId) {
      this.$store.commit("publishGoods/publishGoods/saveSpuId", this.spuId);

      this.loadEditProductDetail(this.spuId);
    }
  },
  methods: {
    async loadEditProductDetail(spuId) {
      //220928131979001
      //337649472946
      //221110093378001
      //221114161278001
      // 单规格 221104105378001
      //多规格 oa spuid 2211111558340002077
      //单规格oa商品，spuId: 220920130878001

      this.$store.dispatch("publishGoods/publishGoods/loadEditProductDetail", spuId);
    },
    cancelClick() {
      this.$router.back();
    },
    async onSubmit() {
      let baseInfoObj = await this.$refs.baseInfoRef.subMitCheck();
      if (!baseInfoObj) {
        return;
      }
      console.log("基本信息", baseInfoObj);

      let saleInfoObj = this.$refs.saleInfoNormalRef.subMitCheck();
      if (!saleInfoObj) {
        return;
      }
      console.log("销售信息", saleInfoObj);

      let deliveryObj = await this.$refs.deliveryInfoRef.subMitCheck();
      if (!deliveryObj) {
        return;
      }
      console.log("物流信息", deliveryObj);

      let graphicObj = await this.$refs.graphicInfoRef.subMitCheck();
      if (!graphicObj) {
        return;
      }
      console.log("图文信息", graphicObj);

      const saveObj = {
        isShowPrice: 1,
        ...baseInfoObj,
        ...saleInfoObj,
        ...deliveryObj,
        ...graphicObj,
        spuId: this.spuId || "",
        isGroup: 1,
      };

      const loading = this.$loading({
        lock: false,
        text: "提交中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        console.log(saveObj);
        const saveResult = await goodsSave(saveObj);

        if (saveResult.code === "0") {
          this.$message.success(`${saveResult.msg}`);

          this.$router.back();
        } else {
          this.$message.error(`${saveResult.msg}`);
        }
      } catch (error) {
        this.$message.error("系统故障请稍后再试");
      } finally {
        loading.close();
      }
    },
  },
};
</script>
<style lang="scss">
@import "./changeOuterMainColor.scss";
</style>

<style lang="scss" scoped>
@import "./changeMainColor.scss";

.publish-goods-container {
  padding: 20px;
  .product-tips {
    color: lightslategray;
    cursor: pointer;
    &:hover {
      color: rgb(51, 51, 51);
    }
  }
}
</style>
